// extracted by mini-css-extract-plugin
module.exports = {"CheckBox":"CheckBox_CheckBox__DzCza","disable":"CheckBox_disable__unlGk","active":"CheckBox_active__lf3lS","tick":"CheckBox_tick__GnTEG"};